import { api } from "../../../axios";

export const signDocument = async (documentId: number, data: object) => {
  const response = await api.post(
    `/signature/submissions/${documentId}/sign_document`,
    data,
    {
      headers: {}
    }
  );

  return response.data;
};
